/**
 * Created by Languagenut on 17/06/2019.
 */


import React  from 'react';
import {Line} from 'react-chartjs-2';
import Translation from '../../store/internationalization-store.js'
/*{id:'listening' , name:'Écouter'},
{id:'speaking' , name:'Parler'},
{id:'reading' , name:'Lire'},
{id:'writing' , name:'Écrire'},*/

export default class LearntLine extends React.Component {


    constructor(props) {
        super();
        this.props = props;
        this.state = {

        };
    }

    componentWillReceiveProps(props){
        this.props  = props;
        this.setState({update:true});
    }

    get($key){

        var response = [];
        var data = this.props[$key] || [];

        for(var idx = 1; idx <= 12; idx++)
        {
            let number = 0;

            for(var jdx = 0 ; jdx < data.length; jdx++)
            {
                if(data[jdx].month == idx)
                {
                    number = data[jdx].total;
                    continue;
                }
            }

            response.push(number)
        }

        return response;
    }

    render(){

        let l = this.props.lines;
        let c = ['#1f1535' , '#4eb4cf' , '#8fd9d2' ,'#c28fd9']
        let d = [];
        let newdata = this.props.data;
    //vocabulary
    //pronance
    //grammer


        for(var i = 0 ; i < l.length; i++)
        {
            d.push({
                    label: l[i],
                    fill: false,
                    lineTension: 0.1,
                    backgroundColor: c[i],
                    borderColor: c[i],
                    pointBackgroundColor: 'rgba(179,181,198,1)',
                    pointBorderColor: '#fff',
                    pointHoverBackgroundColor: '#fff',
                    pointHoverBorderColor: 'rgba(179,181,198,1)',
                    borderCapStyle: 'butt',
                    borderDash: [],
                    borderDashOffset: 0.0,
                    borderJoinStyle: 'miter',
                    pointBorderWidth: 1,
                    pointHoverRadius: 5,
                    pointHoverBorderWidth: 2,
                    pointRadius: 1,
                    pointHitRadius: 10,
                    data: newdata[i]
                }
            )
        }

        let data = {
            labels: this.props.labels,
            datasets:d
        };

        const options = {
            legend:{
                position:'bottom',
                boxWidth:5,
            },
            responsive: true,
            maintainAspectRatio: false,
            scales: {
                yAxes: [
                    {
                        ticks: {
                            min:0,
                        },
                        type: 'linear',
                        display: true,
                        position: 'left',
                        id: 'y-axis-1',
                    },
                ]
            }
        };
            return  <div>
                <Line  height={300} data={data}  options={options} />
            </div>
    }
}